import React, { ReactNode, FunctionComponent } from 'react';

import { ImageSizeType } from '../types/ImageSizeType';

export const TileContext = React.createContext({});

type TileContextProviderProps = {
    children: ReactNode;
    imageSize: ImageSizeType;
};

export const TileContextProvider: FunctionComponent<TileContextProviderProps> = props => {
    const { children, ...values } = props;

    return <TileContext.Provider value={values}>{children}</TileContext.Provider>;
};
